module.exports = __webpack_public_path__ + "img/112ne.7763ec83.svg";